const RESOURCE_NAME = '/shipments-carriers';
import restApi from "@/api/rest-api-object";

export default axios => ({
    ...restApi(axios, RESOURCE_NAME),
    getStandardizedCarriers(params) {
        return axios.get(`${RESOURCE_NAME}/standardized-carriers`, {params});
    }
});